export const log = (arg, ...rest) => {
    if (typeof arg === 'string') {
        console.log(`AFITD: ${arg}`, ...rest);
    } else {
        console.log(`AFITD:`, arg, ...rest);
    }
};
